import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './hooks/useAuth';
import { ToastProvider } from './hooks/useToast';
import { MarinaModulesRefreshProvider } from './context/MarinaModulesRefreshContext';
import { OnboardingNavRefreshProvider } from './context/OnboardingNavRefreshContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Layout } from './components/Layout';
import { LoginPage } from './pages/Login';
import { ForgotPasswordPage } from './pages/ForgotPassword';
import { ResetPasswordPage } from './pages/ResetPassword';
import { InviteAcceptPage } from './pages/InviteAccept';
import { DashboardPage } from './pages/Dashboard';
import { BookingsPage } from './pages/Bookings';
import { BerthsPage } from './pages/Berths';
import { PricingPage } from './pages/Pricing';
import { ParkingSpotsPage } from './pages/ParkingSpots';
import { ParkingPricingPage } from './pages/ParkingPricing';
import { KnowledgePage } from './pages/Knowledge';
import { AccessCodesPage } from './pages/AccessCodes';
import { ModulesPage } from './pages/Modules';
import { AdditionalServicesPage } from './pages/AdditionalServices';
import { WidgetSettingsPage } from './pages/WidgetSettings';
import { OrgOverviewPage } from './pages/OrgOverview';
import { TeamPage } from './pages/Team';
import { SignupPage } from './pages/Signup';
import { OnboardingPage } from './pages/Onboarding';
import { SettingsPage } from './pages/Settings';
import { AnalyticsPage } from './pages/Analytics';
import { SuperadminOverviewPage } from './pages/superadmin/Overview';
import { SuperadminOrgsPage } from './pages/superadmin/Orgs';
import { SuperadminOrgDetailPage } from './pages/superadmin/OrgDetail';
import { SuperadminMarinasPage } from './pages/superadmin/Marinas';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ToastProvider>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/invite/:token" element={<InviteAcceptPage />} />
            <Route path="/signup" element={<SignupPage />} />

            {/* Protected routes */}
            <Route
              element={
                <ProtectedRoute>
                  <OnboardingNavRefreshProvider>
                    <MarinaModulesRefreshProvider>
                      <Layout />
                    </MarinaModulesRefreshProvider>
                  </OnboardingNavRefreshProvider>
                </ProtectedRoute>
              }
            >
              <Route index element={<DashboardPage />} />
              <Route path="org" element={<OrgOverviewPage />} />
              <Route path="team" element={<TeamPage />} />
              <Route path="bookings" element={<BookingsPage />} />
              <Route path="berths" element={<BerthsPage />} />
              <Route path="pricing" element={<PricingPage />} />
              <Route path="parking-spots" element={<ParkingSpotsPage />} />
              <Route path="parking-pricing" element={<ParkingPricingPage />} />
              <Route path="knowledge" element={<KnowledgePage />} />
              <Route path="access-codes" element={<AccessCodesPage />} />
              <Route path="modules" element={<ModulesPage />} />
              <Route path="additional-services" element={<AdditionalServicesPage />} />
              <Route path="widget" element={<WidgetSettingsPage />} />
              <Route path="analytics" element={<AnalyticsPage />} />
              <Route path="settings" element={<SettingsPage />} />
              <Route path="onboarding" element={<OnboardingPage />} />

              {/* Superadmin-only routes */}
              <Route path="superadmin" element={<SuperadminOverviewPage />} />
              <Route path="superadmin/orgs" element={<SuperadminOrgsPage />} />
              <Route path="superadmin/orgs/:orgId" element={<SuperadminOrgDetailPage />} />
              <Route path="superadmin/marinas" element={<SuperadminMarinasPage />} />

              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>

            {/* Unknown public routes → login */}
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </ToastProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
